import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/accueil/carteee.png")